import React, { lazy } from 'react';

const SupplierRefund = lazy(() =>
  import('../SupplierAccountListing/SupplierAccountListing').then(module => ({
    default: module.SupplierAccountListing,
  })),
);

const SupplierAllocation = lazy(() =>
  import('../SupplierAccountListing/SupplierAllocation').then(module => ({
    default: module.SupplierAllocation,
  })),
);

const SupplierRefundForm = lazy(() =>
  import('../SupplierAccountFormV2/SupplierRefundForm').then(module => ({
    default: module.SupplierRefundForm,
  })),
);

const SupplierLedgerMobileView = lazy(() =>
  import(
    '../../AccountLedgerModule/AccountLedgerMobileView/PaymentPDF/PaymentPDFMobile'
  ).then(module => ({
    default: module.PVMobile,
  })),
);

const RefundsPreviewDetailPDF = lazy(() =>
  import('../SupplierAccountPDF/PaymentsPreviewDetailPDF').then(module => ({
    default: module.PaymentsPreviewDetailPDF,
  })),
);

const SupplierLedgerDetail = lazy(() =>
  import('../SupplierAccountDetail/SupplierRefundDetail').then(module => ({
    default: module.SupplierRefundDetail,
  })),
);

const SupplierPreviewDetailPDF = lazy(() =>
  import('../SupplierAccountPDF/SupplierPreviewDetailPDF').then(module => ({
    default: module.SupplierPreviewDetailPDF,
  })),
);

export const SupplierRefundRoutes = [
  {
    props: {
      exact: true,
      path: `/supplier-account/account-transaction/refunds`,
    },
    component: (
      <SupplierRefund
        accountType="supplier"
        transactionType="Refunds"
        supplierType="withoutID"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/supplier-account/account-transaction/:ID/refunds`,
    },
    component: (
      <SupplierRefund
        accountType="supplier"
        transactionType="Refunds"
        supplierType="withID"
      />
    ),
  },
  ///////////////
  //// FORMS ////
  ///////////////
  {
    props: {
      exact: true,
      path: '/supplier-account/account-transaction/refunds/add',
    },
    component: (
      <SupplierRefundForm
        transactionType="Refunds"
        accountType="supplier"
        formMode="add"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/edit/:transactionID',
    },
    component: (
      <SupplierRefundForm
        transactionType="Refunds"
        accountType="supplier"
        formMode="edit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/approve-reject/:transactionID',
    },
    component: (
      <SupplierRefundForm
        transactionType="Refunds"
        accountType="supplier"
        formMode="approve-reject"
        mode="approval"
      />
    ),
  },

  // workdesk

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/approve-reject/:refTable/workdesk/:transactionID',
    },
    component: (
      <SupplierRefundForm
        transactionType="Refunds"
        accountType="supplier"
        formMode="approve-reject"
        mode="approval"
        type="workdesk"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/resubmit/:transactionID',
    },
    component: (
      <SupplierRefundForm
        transactionType="Refunds"
        accountType="supplier"
        formMode="resubmit"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withoutID"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/detail/workdesk/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withoutID"
        modeType="workdesk"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/:ID/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withID"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/supplier/submenu/:ID/supplier-ledger/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withID"
        modeType="ledger"
      />
    ),
  },

  {
    props: {
      exact: true,
      path: '/supplier-account/account-transaction/:ID/refunds/mobile-view',
    },
    component: (
      <SupplierLedgerMobileView
      // transactionType="Payments"
      // accountType="supplier"
      />
    ),
  },

  //PDF Preview Routing by Aqil
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/:ID/refunds/:transactionID/preview',
    },
    component: (
      <RefundsPreviewDetailPDF
        transactionType="Refunds"
        accountType="supplier"
      />
    ),
  },

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/:transactionID/refunds/preview',
    },
    component: (
      <RefundsPreviewDetailPDF
        transactionType="Refunds"
        accountType="supplier"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/:transactionID/preview',
    },
    component: (
      <RefundsPreviewDetailPDF
        transactionType="Refunds"
        accountType="supplier"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/:ID/refunds/:transactionID/preview',
    },
    component: (
      <RefundsPreviewDetailPDF
        transactionType="Refunds"
        accountType="supplier"
      />
    ),
  },
  // End Preview

  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/allocation/:transactionID',
    },
    component: <SupplierAllocation transactionType="Refunds" />,
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withoutID"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/refunds/detail/workdesk/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withoutID"
        modeType="workdesk"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier-account/account-transaction/:ID/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail transactionType="Refunds" accountType="supplier" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/supplier/submenu/:ID/supplier-ledger/refunds/detail/:transactionID',
    },
    component: (
      <SupplierLedgerDetail
        transactionType="Refunds"
        accountType="supplier"
        supplierType="withID"
        modeType="ledger"
      />
    ),
  },

  /////////////////////ELETTER PREVIEW PDF///////////////
//   {
//     props: {
//       exact: true,
//       path:
//         '/supplier-account/account-transaction/:ID/payments/:transactionID/e-letter',
//     },
//     component: (
//       <SupplierPreviewDetailPDF
//         docType="payment"
//         accountType="supplier-account"
//       />
//     ),
//   },
//   {
//     props: {
//       exact: true,
//       path:
//         '/supplier-account/account-transaction/payments/:transactionID/e-letter',
//     },
//     component: (
//       <SupplierPreviewDetailPDF docType="payment" accountType="supplier" />
//     ),
//   },
];
